import React, { Component } from 'react'
// import CusCard from '../components/CusCard'
import CusCard from '../containers/CusCardContainer'
import '../../node_modules/font-awesome/css/font-awesome.min.css'
import { Row } from 'react-bootstrap';



class EditOrDeleteManualTransaction extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        console.warn('Manage Props:',this.props)

        return (


            <div>
                {/* <CustomHeader></CustomHeader> */}

                <Row>
                    <CusCard data1="Add Manual" data2="Transaction" icon="bookmark" link="./ManualTransaction" ></CusCard>
                    <CusCard data1="View/Edit Manual" data2="Transaction" icon="edit" link="./EditManualTransaction"></CusCard>
                    <CusCard data1="Add Bulk Manual" data2="Transaction" icon="edit" link="./AddBulkTransaction"></CusCard>
                </Row>


            </div>



        );
    }
}


export default EditOrDeleteManualTransaction;